// export type RailProfileName =
//   | "REPW002B"
//   | "REPW008B"
//   | "REPW200B"
//   | "REPW620F"
//   | "REPW792"
//   | "REPW901"
//   | "REPW979A";

// type RailProfileRecord = Record<RailProfileName, IdealProfileShape>;

const REPW002B = {
    arcs: [
        {
            center: [585.8000000000001, 76.2],
            radius: 508.0,
            start_angle: 177.133981,
            end_angle: 184.443742,
        },
        {
            center: [-446.0, 76.2],
            radius: 508.0,
            start_angle: 355.568292,
            end_angle: 2.866019,
        },
        {
            center: [136.52499999999998, 6.997123000000002],
            radius: 3.175,
            start_angle: 0.0,
            end_angle: 78.690067,
        },
        {
            center: [136.52499999999998, 6.970354],
            radius: 3.175,
            start_angle: 0.0,
            end_angle: 79.479217,
        },
        {
            center: [138.11249999999995, 1.5875000000000057],
            radius: 1.5875,
            start_angle: 270.0,
            end_angle: 0.0,
        },
        {
            center: [138.11249999999995, 1.5875000000000057],
            radius: 1.5875,
            start_angle: 270.0,
            end_angle: 0.0,
        },
        {
            center: [95.15438099999994, 38.070056],
            radius: 15.875,
            start_angle: 184.443742,
            end_angle: 249.817297,
        },
        {
            center: [44.65361599999994, 38.173107],
            radius: 15.875,
            start_angle: 290.335944,
            end_angle: 355.568292,
        },
        {
            center: [1.5874999999999773, 1.5875000000000057],
            radius: 1.5875,
            start_angle: 180.0,
            end_angle: 270.0,
        },
        {
            center: [3.1749999999999545, 6.972466999999995],
            radius: 3.175,
            start_angle: 100.565872,
            end_angle: 180.0,
        },
        {
            center: [100.66499999999996, 101.6],
            radius: 22.225,
            start_angle: 155.76705,
            end_angle: 180.0,
        },
        {
            center: [87.63645399999996, 107.464269],
            radius: 7.9375,
            start_angle: 110.189131,
            end_angle: 155.76705,
        },
        {
            center: [39.13499999999999, 101.6],
            radius: 22.225,
            start_angle: 360.0,
            end_angle: 24.23295,
        },
        {
            center: [52.163546, 107.464269],
            radius: 7.9375,
            start_angle: 24.23295,
            end_angle: 69.810869,
        },
        {
            center: [101.64499999999998, 124.455274],
            radius: 3.175,
            start_angle: 290.191181,
            end_angle: 0.0,
        },
        {
            center: [38.14499999999998, 124.459025],
            radius: 3.175,
            start_angle: 180.0,
            end_angle: 249.810542,
        },
        {
            center: [69.89999999999998, -69.73],
            radius: 228.6,
            start_angle: 84.092772,
            end_angle: 95.909897,
        },
        {
            center: [47.66999999999996, 145.022502],
            radius: 12.7,
            start_angle: 95.909897,
            end_angle: 180.0,
        },
        {
            center: [92.12, 145.023537],
            radius: 12.7,
            start_angle: 0.0,
            end_angle: 84.092772,
        },
        {
            center: [117.85171400000002, 33.110743],
            radius: 19.05,
            start_angle: 249.660778,
            end_angle: 259.131475,
        },
        {
            center: [21.886247000000026, 33.122226],
            radius: 19.05,
            start_angle: 280.651389,
            end_angle: 290.376436,
        },
    ],
    lines: [
        {
            x1: 1.5900000000000318,
            x2: 138.11,
            y1: 0.0,
            y2: 0.0,
        },
        {
            x1: 139.69999999999993,
            x2: 139.69999999999993,
            y1: 1.5900000000000034,
            y2: 6.969999999999999,
        },
        {
            x1: 0.0,
            x2: 0.0,
            y1: 1.5900000000000034,
            y2: 6.969999999999999,
        },
        {
            x1: 34.97000000000003,
            x2: 34.97000000000003,
            y1: 124.46000000000001,
            y2: 145.02,
        },
        {
            x1: 104.81999999999994,
            x2: 104.81999999999994,
            y1: 124.46000000000001,
            y2: 145.02,
        },
        {
            x1: 54.89999999999998,
            x2: 37.049999999999955,
            y1: 114.91,
            y2: 121.48,
        },
        {
            x1: 84.81999999999994,
            x2: 102.74000000000001,
            y1: 114.88,
            y2: 121.48,
        },
        {
            x1: 25.409999999999968,
            x2: 2.590000000000032,
            y1: 14.400000000000006,
            y2: 10.090000000000003,
        },
        {
            x1: 50.16999999999996,
            x2: 28.519999999999982,
            y1: 23.299999999999997,
            y2: 15.260000000000005,
        },
        {
            x1: 111.23000000000002,
            x2: 89.82999999999993,
            y1: 15.25,
            y2: 23.120000000000005,
        },
        {
            x1: 137.10000000000002,
            x2: 114.25999999999999,
            y1: 10.090000000000003,
            y2: 14.400000000000006,
        },
    ],
};

const REPW008B = {
    arcs: [
        {
            center: [138.11249999999998, 1.5874999999999915],
            radius: 1.5875,
            start_angle: 270.0,
            end_angle: 360.0,
        },
        {
            center: [136.52499999999998, 6.081519999999998],
            radius: 3.175,
            start_angle: 0.0,
            end_angle: 79.695153,
        },
        {
            center: [1.5874999999999773, 1.5874999999999915],
            radius: 1.5875,
            start_angle: 180.0,
            end_angle: 270.0,
        },
        {
            center: [114.13499199999998, 32.741806],
            radius: 19.05,
            start_angle: 250.016894,
            end_angle: 259.695392,
        },
        {
            center: [584.9938, 71.4375],
            radius: 508.0,
            start_angle: 180.0,
            end_angle: 184.173272,
        },
        {
            center: [87.71489399999996, 94.88781499999999],
            radius: 7.9375,
            start_angle: 109.983119,
            end_angle: 151.663642,
        },
        {
            center: [100.29041299999994, 88.10629800000001],
            radius: 22.225,
            start_angle: 151.663642,
            end_angle: 172.642581,
        },
        {
            center: [92.59036199999997, 35.50858199999999],
            radius: 14.2875,
            start_angle: 184.173272,
            end_angle: 250.016881,
        },
        {
            center: [229.39379999999997, 71.4375],
            radius: 152.4,
            start_angle: 172.643047,
            end_angle: 180.0,
        },
        {
            center: [51.98510599999997, 94.88781499999999],
            radius: 7.9375,
            start_angle: 28.336358,
            end_angle: 70.016881,
        },
        {
            center: [39.40958699999999, 88.10629800000001],
            radius: 22.225,
            start_angle: 7.357419,
            end_angle: 28.336358,
        },
        {
            center: [-89.69380000000001, 71.4375],
            radius: 152.4,
            start_angle: 360.0,
            end_angle: 7.356953,
        },
        {
            center: [-445.2938, 71.4375],
            radius: 508.0,
            start_angle: 355.826728,
            end_angle: 360.0,
        },
        {
            center: [69.84999999999997, -85.725],
            radius: 228.6,
            start_angle: 84.091439,
            end_angle: 89.999994,
        },
        {
            center: [92.07499999999999, 129.028019],
            radius: 12.7,
            start_angle: 0.0,
            end_angle: 84.091439,
        },
        {
            center: [101.59999999999997, 111.76137299999999],
            radius: 3.175,
            start_angle: 289.982708,
            end_angle: 0.0,
        },
        {
            center: [69.84999999999997, -85.725],
            radius: 228.6,
            start_angle: 90.000006,
            end_angle: 95.908561,
        },
        {
            center: [47.625, 129.028019],
            radius: 12.7,
            start_angle: 95.908561,
            end_angle: 180.0,
        },
        {
            center: [38.099999999999966, 111.76137299999999],
            radius: 3.175,
            start_angle: 180.0,
            end_angle: 250.017292,
        },
        {
            center: [47.10963799999996, 35.50858199999999],
            radius: 14.2875,
            start_angle: 289.983119,
            end_angle: 355.826728,
        },
        {
            center: [25.565007999999978, 32.741806],
            radius: 19.05,
            start_angle: 280.304608,
            end_angle: 289.983106,
        },
        {
            center: [3.1749999999999545, 6.081487999999993],
            radius: 3.175,
            start_angle: 100.30425,
            end_angle: 180.0,
        },
    ],
    lines: [
        {
            x1: 1.5874999999999773,
            x2: 138.11249999999998,
            y1: 0.0,
            y2: 0.0,
        },
        {
            x1: 0.0,
            x2: 0.0,
            y1: 1.5874999999999915,
            y2: 6.081499999999991,
        },
        {
            x1: 139.69999999999996,
            x2: 139.69999999999996,
            y1: 1.5874999999999915,
            y2: 6.081499999999991,
        },
        {
            x1: 110.72729999999999,
            x2: 137.09299999999996,
            y1: 13.999099999999999,
            y2: 9.205299999999994,
        },
        {
            x1: 87.70769999999999,
            x2: 107.62479999999996,
            y1: 22.0813,
            y2: 14.838699999999989,
        },
        {
            x1: 104.77499999999998,
            x2: 104.77499999999998,
            y1: 111.76140000000001,
            y2: 129.028,
        },
        {
            x1: 85.00229999999999,
            x2: 102.68499999999995,
            y1: 102.3474,
            y2: 108.7775,
        },
        {
            x1: 34.924999999999955,
            x2: 34.924999999999955,
            y1: 111.76140000000001,
            y2: 129.028,
        },
        {
            x1: 54.6977,
            x2: 37.014999999999986,
            y1: 102.3474,
            y2: 108.7775,
        },
        {
            x1: 51.9923,
            x2: 32.075199999999995,
            y1: 22.0813,
            y2: 14.838699999999989,
        },
        {
            x1: 28.972699999999975,
            x2: 2.607099999999946,
            y1: 13.999099999999999,
            y2: 9.205299999999994,
        },
    ],
};

const REPW200B = {
    arcs: [
        {
            center: [37.11950999999999, 124.817872],
            radius: 3.175,
            start_angle: 177.137675,
            end_angle: 250.016886,
        },
        {
            center: [47.624999999999986, 144.18880000000001],
            radius: 12.7,
            start_angle: 103.287356,
            end_angle: 177.137639,
        },
        {
            center: [62.80546899999999, 79.264902],
            radius: 79.375,
            start_angle: 91.790783,
            end_angle: 103.180739,
        },
        {
            center: [69.85, -146.05],
            radius: 304.8,
            start_angle: 88.209214,
            end_angle: 91.790786,
        },
        {
            center: [76.89453099999999, 79.264902],
            radius: 79.375,
            start_angle: 76.819261,
            end_angle: 88.209214,
        },
        {
            center: [92.07499999999999, 144.18880000000001],
            radius: 12.7,
            start_angle: 2.862361,
            end_angle: 76.712644,
        },
        {
            center: [102.58049, 124.817872],
            radius: 3.175,
            start_angle: 289.983114,
            end_angle: 2.862325,
        },
        {
            center: [87.702722, 107.583373],
            radius: 7.9375,
            start_angle: 109.983036,
            end_angle: 155.242172,
        },
        {
            center: [100.67699999999999, 101.6],
            radius: 22.225,
            start_angle: 155.242172,
            end_angle: 176.957067,
        },
        {
            center: [585.7875, 76.20000000000002],
            radius: 508.0,
            start_angle: 177.000775,
            end_angle: 184.469292,
        },
        {
            center: [95.15893399999999, 37.851261],
            radius: 15.875,
            start_angle: 184.469292,
            end_angle: 250.016892,
        },
        {
            center: [119.69364099999999, 32.307954],
            radius: 19.05,
            start_angle: 250.016847,
            end_angle: 264.160428,
        },
        {
            center: [136.52499999999998, 8.245652],
            radius: 3.175,
            start_angle: 0.0,
            end_angle: 84.160547,
        },
        {
            center: [138.11249999999998, 1.5874999999999986],
            radius: 1.5875,
            start_angle: 270.0,
            end_angle: 0.0,
        },
        {
            center: [1.5874999999999773, 1.5874999999999986],
            radius: 1.5875,
            start_angle: 180.0,
            end_angle: 270.0,
        },
        {
            center: [3.174999999999983, 8.245652],
            radius: 3.175,
            start_angle: 95.839453,
            end_angle: 180.0,
        },
        {
            center: [20.00635899999999, 32.307954],
            radius: 19.05,
            start_angle: 275.839572,
            end_angle: 289.983153,
        },
        {
            center: [44.54106599999999, 37.851261],
            radius: 15.875,
            start_angle: 289.983108,
            end_angle: 355.530708,
        },
        {
            center: [-446.0875, 76.20000000000002],
            radius: 508.0,
            start_angle: 355.530708,
            end_angle: 2.999225,
        },
        {
            center: [39.022999999999996, 101.6],
            radius: 22.225,
            start_angle: 3.042933,
            end_angle: 24.757828,
        },
        {
            center: [51.997277999999994, 107.583373],
            radius: 7.9375,
            start_angle: 24.757828,
            end_angle: 70.016964,
        },
    ],
    lines: [
        {
            x1: 54.70989999999999,
            x2: 36.034499999999994,
            y1: 115.043,
            y2: 121.834,
        },
        {
            x1: 33.948499999999996,
            x2: 34.940799999999996,
            y1: 124.97640000000001,
            y2: 144.823,
        },
        {
            x1: 104.75919999999999,
            x2: 105.7515,
            y1: 144.823,
            y2: 124.97640000000001,
        },
        {
            x1: 103.66549999999998,
            x2: 84.99009999999998,
            y1: 121.834,
            y2: 115.043,
        },
        {
            x1: 89.73379999999999,
            x2: 113.18339999999999,
            y1: 22.931999999999995,
            y2: 14.404900000000005,
        },
        {
            x1: 117.7554,
            x2: 136.84799999999998,
            y1: 13.3568,
            y2: 11.404199999999996,
        },
        {
            x1: 139.7,
            x2: 139.7,
            y1: 8.245699999999992,
            y2: 1.5874999999999986,
        },
        {
            x1: 138.11249999999998,
            x2: 1.5874999999999773,
            y1: 0.0,
            y2: 0.0,
        },
        {
            x1: 0.0,
            x2: 0.0,
            y1: 1.5874999999999986,
            y2: 8.245699999999992,
        },
        {
            x1: 2.852000000000004,
            x2: 21.944599999999994,
            y1: 11.404199999999996,
            y2: 13.3568,
        },
        {
            x1: 26.516599999999997,
            x2: 49.966199999999986,
            y1: 14.404900000000005,
            y2: 22.931999999999995,
        },
    ],
};

const REPW620F = {
    arcs: [
        {
            center: [119.28104000000167, 32.45408500000485],
            radius: 19.05,
            start_angle: 249.965108,
            end_angle: 263.914772,
        },
        {
            center: [138.0900000000256, 1.5900000000110595],
            radius: 1.59,
            start_angle: 270.0,
            end_angle: 360.0,
        },
        {
            center: [136.5100000000093, 8.262071000004653],
            radius: 3.17,
            start_angle: 0.0,
            end_angle: 83.873067,
        },
        {
            center: [94.84000000002561, 37.02668900000572],
            radius: 15.0,
            start_angle: 180.0,
            end_angle: 249.995347,
        },
        {
            center: [69.84000000002561, -146.04999999998836],
            radius: 304.8,
            start_angle: 90.0,
            end_angle: 90.000003,
        },
        {
            center: [102.58816200000001, 124.82906899999944],
            radius: 3.17,
            start_angle: 289.939967,
            end_angle: 2.757894,
        },
        {
            center: [87.84000000002561, 107.57737400000042],
            radius: 8.0,
            start_angle: 110.002422,
            end_angle: 180.0,
        },
        {
            center: [20.398960000020452, 32.45408500000485],
            radius: 19.05,
            start_angle: 276.085228,
            end_angle: 290.034892,
        },
        {
            center: [1.5900000000256114, 1.5900000000110595],
            radius: 1.59,
            start_angle: 180.0,
            end_angle: 270.0,
        },
        {
            center: [3.1700000000128057, 8.262071000004653],
            radius: 3.17,
            start_angle: 96.126933,
            end_angle: 180.0,
        },
        {
            center: [44.84000000002561, 37.02668900000572],
            radius: 15.0,
            start_angle: 290.004653,
            end_angle: 0.0,
        },
        {
            center: [69.84000000002561, -146.04999999998836],
            radius: 304.8,
            start_angle: 89.999997,
            end_angle: 90.0,
        },
        {
            center: [37.09183800002211, 124.82906899999944],
            radius: 3.17,
            start_angle: 177.242106,
            end_angle: 250.060033,
        },
        {
            center: [51.84000000002561, 107.57737400000042],
            radius: 8.0,
            start_angle: 0.0,
            end_angle: 69.997578,
        },
        {
            center: [69.84000000002561, -146.04999999998836],
            radius: 304.8,
            start_angle: 88.872053,
            end_angle: 90.0,
        },
        {
            center: [75.84000000002561, 79.31000000001222],
            radius: 79.37,
            start_angle: 75.894842,
            end_angle: 90.0,
        },
        {
            center: [92.08763400002499, 143.96990500000538],
            radius: 12.7,
            start_angle: 2.862119,
            end_angle: 75.894842,
        },
        {
            center: [69.84000000002561, -146.04999999998836],
            radius: 304.8,
            start_angle: 90.0,
            end_angle: 91.127947,
        },
        {
            center: [63.84000000002561, 79.31000000001222],
            radius: 79.37,
            start_angle: 90.0,
            end_angle: 104.105158,
        },
        {
            center: [47.59236600002623, 143.96990500000538],
            radius: 12.7,
            start_angle: 104.105158,
            end_angle: 177.137881,
        },
    ],
    lines: [
        {
            x1: 69.84000000002561,
            x2: 138.0900000000256,
            y1: 0.0,
            y2: 0.0,
        },
        {
            x1: 139.68000000002212,
            x2: 139.68000000002212,
            y1: 8.520000000004075,
            y2: 1.5900000000110595,
        },
        {
            x1: 79.84000000002561,
            x2: 79.84000000002561,
            y1: 107.58000000000175,
            y2: 37.029999999998836,
        },
        {
            x1: 69.84000000002561,
            x2: 1.5900000000256114,
            y1: 0.0,
            y2: 0.0,
        },
        {
            x1: 0.0,
            x2: 0.0,
            y1: 8.260000000009313,
            y2: 1.5900000000110595,
        },
        {
            x1: 59.84000000002561,
            x2: 59.84000000002561,
            y1: 107.58000000000175,
            y2: 37.029999999998836,
        },
        {
            x1: 54.69000000000233,
            x2: 36.01000000000931,
            y1: 115.05000000000291,
            y2: 121.85000000000582,
        },
        {
            x1: 84.9200000000128,
            x2: 103.6700000000128,
            y1: 115.02999999999884,
            y2: 121.85000000000582,
        },
        {
            x1: 49.970000000001164,
            x2: 26.93000000002212,
            y1: 22.930000000007567,
            y2: 14.560000000012224,
        },
        {
            x1: 89.71000000002095,
            x2: 112.75,
            y1: 22.930000000007567,
            y2: 14.560000000012224,
        },
        {
            x1: 22.470000000001164,
            x2: 2.830000000016298,
            y1: 13.510000000009313,
            y2: 11.410000000003492,
        },
        {
            x1: 117.44000000000233,
            x2: 136.81000000002678,
            y1: 13.5,
            y2: 11.420000000012806,
        },
        {
            x1: 104.77000000001863,
            x2: 105.75,
            y1: 144.60000000000582,
            y2: 124.98000000001048,
        },
        {
            x1: 34.91000000000349,
            x2: 33.93000000002212,
            y1: 144.60000000000582,
            y2: 124.98000000001048,
        },
    ],
};

const REPW792 = {
    arcs: [
        {
            center: [138.50109999999404, 1.4966500000009546],
            radius: 1.5,
            start_angle: 270.0,
            end_angle: 360.0,
        },
        {
            center: [1.5010999999940395, 1.4966500000009546],
            radius: 1.5,
            start_angle: 180.0,
            end_angle: 270.0,
        },
        {
            center: [20.153923999983817, 33.31170900000143],
            radius: 20.0,
            start_angle: 275.710658,
            end_angle: 289.983014,
        },
        {
            center: [119.84828999999445, 33.31164100000751],
            radius: 20.0,
            start_angle: 250.016917,
            end_angle: 264.289511,
        },
        {
            center: [45.00109999999404, 37.026685999997426],
            radius: 15.0,
            start_angle: 289.983006,
            end_angle: 360.0,
        },
        {
            center: [95.00109999999404, 37.026645000005374],
            radius: 15.0,
            start_angle: 180.0,
            end_angle: 250.016864,
        },
        {
            center: [3.0010999999940395, 8.481689000007464],
            radius: 3.0,
            start_angle: 95.710619,
            end_angle: 180.0,
        },
        {
            center: [137.00109999999404, 8.481677999996464],
            radius: 3.0,
            start_angle: 0.0,
            end_angle: 84.289611,
        },
        {
            center: [88.00109999999404, 107.5696270000044],
            radius: 8.0,
            start_angle: 109.983061,
            end_angle: 180.0,
        },
        {
            center: [52.00109999999404, 107.5696270000044],
            radius: 8.0,
            start_angle: 0.0,
            end_angle: 70.016939,
        },
        {
            center: [37.10357799998019, 124.69161000000895],
            radius: 3.0,
            start_angle: 177.137544,
            end_angle: 250.016781,
        },
        {
            center: [102.89857699998538, 124.69154400000116],
            radius: 3.0,
            start_angle: 289.983086,
            end_angle: 2.862314,
        },
        {
            center: [47.760244999983115, 143.5822530000005],
            radius: 12.7,
            start_angle: 105.419289,
            end_angle: 177.136739,
        },
        {
            center: [92.24193999997806, 143.58255200000713],
            radius: 12.7,
            start_angle: 2.861908,
            end_angle: 74.581742,
        },
        {
            center: [70.00109999999404, -146.25334999999905],
            radius: 305.0,
            start_angle: 88.892661,
            end_angle: 91.107044,
        },
        {
            center: [74.34933599998476, 78.70463000000746],
            radius: 80.0,
            start_angle: 74.581739,
            end_angle: 88.892661,
        },
        {
            center: [65.65401399999973, 78.70465200000035],
            radius: 80.0,
            start_angle: 91.107044,
            end_angle: 105.419289,
        },
    ],
    lines: [
        {
            x1: 70.0,
            x2: 1.5,
            y1: 0.0,
            y2: 0.0,
        },
        {
            x1: 70.0,
            x2: 138.5,
            y1: 0.0,
            y2: 0.0,
        },
        {
            x1: 80.0,
            x2: 80.0,
            y1: 107.57000000000698,
            y2: 37.029999999998836,
        },
        {
            x1: 60.0,
            x2: 60.0,
            y1: 107.57000000000698,
            y2: 37.029999999998836,
        },
        {
            x1: 0.0,
            x2: 0.0,
            y1: 1.5,
            y2: 8.480000000010477,
        },
        {
            x1: 89.86999999999534,
            x2: 113.00999999998021,
            y1: 22.930000000007567,
            y2: 14.520000000004075,
        },
        {
            x1: 2.6999999999825377,
            x2: 22.139999999984866,
            y1: 11.470000000001164,
            y2: 13.410000000003492,
        },
        {
            x1: 50.13000000000466,
            x2: 26.989999999990687,
            y1: 22.930000000007567,
            y2: 14.520000000004075,
        },
        {
            x1: 54.73999999999069,
            x2: 36.079999999987194,
            y1: 115.08999999999651,
            y2: 121.8700000000099,
        },
        {
            x1: 85.26999999998952,
            x2: 103.9199999999837,
            y1: 115.08999999999651,
            y2: 121.8700000000099,
        },
        {
            x1: 35.079999999987194,
            x2: 34.10999999998603,
            y1: 144.22000000000116,
            y2: 124.83999999999651,
        },
        {
            x1: 104.92999999999302,
            x2: 105.88999999998487,
            y1: 144.22000000000116,
            y2: 124.83999999999651,
        },
        {
            x1: 137.29999999998836,
            x2: 117.85999999998603,
            y1: 11.470000000001164,
            y2: 13.410000000003492,
        },
        {
            x1: 140.0,
            x2: 140.0,
            y1: 1.5,
            y2: 8.480000000010477,
        },
    ],
};

const REPW901 = {
    arcs: [
        {
            center: [133.532254, 52.778186000000005],
            radius: 40.0,
            start_angle: 250.016483,
            end_angle: 265.914169,
        },
        {
            center: [146.0, 7.775499000000011],
            radius: 4.0,
            start_angle: 0.0,
            end_angle: 85.914761,
        },
        {
            center: [148.0, 2.0],
            radius: 2.0,
            start_angle: 270.0,
            end_angle: 360.0,
        },
        {
            center: [203.24999999999997, 60.25],
            radius: 120.0,
            start_angle: 180.0,
            end_angle: 193.198628,
        },
        {
            center: [203.24999999999997, 92.25],
            radius: 120.0,
            start_angle: 167.008442,
            end_angle: 180.0,
        },
        {
            center: [109.052505, 136.574881],
            radius: 3.0,
            start_angle: 289.982767,
            end_angle: 2.862494,
        },
        {
            center: [75.0, -128.0],
            radius: 300.0,
            start_angle: 88.046217,
            end_angle: 90.0,
        },
        {
            center: [85.22799999999998, 91.82560000000001],
            radius: 80.0,
            start_angle: 78.610947,
            end_angle: 90.0,
        },
        {
            center: [120.51839999999999, 111.77170000000001],
            radius: 35.0,
            start_angle: 162.009694,
            end_angle: 167.701453,
        },
        {
            center: [93.88735399999999, 120.419671],
            radius: 7.0,
            start_angle: 109.983069,
            end_angle: 162.009694,
        },
        {
            center: [120.52249999999998, 40.72540000000001],
            radius: 35.0,
            start_angle: 193.002383,
            end_angle: 197.986844,
        },
        {
            center: [93.890931, 32.079038999999995],
            radius: 7.0,
            start_angle: 197.986844,
            end_angle: 250.016967,
        },
        {
            center: [16.467745999999998, 52.778186000000005],
            radius: 40.0,
            start_angle: 274.085831,
            end_angle: 289.983517,
        },
        {
            center: [4.000000000000007, 7.775499000000011],
            radius: 4.0,
            start_angle: 94.085239,
            end_angle: 180.0,
        },
        {
            center: [2.0, 2.0],
            radius: 2.0,
            start_angle: 180.0,
            end_angle: 270.0,
        },
        {
            center: [-53.25, 60.25],
            radius: 120.0,
            start_angle: 346.801372,
            end_angle: 360.0,
        },
        {
            center: [-53.25, 92.25],
            radius: 120.0,
            start_angle: 360.0,
            end_angle: 12.991558,
        },
        {
            center: [40.947494999999996, 136.574881],
            radius: 3.0,
            start_angle: 177.137506,
            end_angle: 250.017233,
        },
        {
            center: [75.0, -128.0],
            radius: 300.0,
            start_angle: 90.0,
            end_angle: 91.953783,
        },
        {
            center: [64.77199999999999, 91.82560000000001],
            radius: 80.0,
            start_angle: 90.0,
            end_angle: 101.389053,
        },
        {
            center: [29.481599999999993, 111.77170000000001],
            radius: 35.0,
            start_angle: 12.298547,
            end_angle: 17.990306,
        },
        {
            center: [56.112646000000005, 120.419671],
            radius: 7.0,
            start_angle: 17.990306,
            end_angle: 70.016931,
        },
        {
            center: [29.4775, 40.72540000000001],
            radius: 35.0,
            start_angle: 342.013156,
            end_angle: 346.997617,
        },
        {
            center: [56.109069, 32.079038999999995],
            radius: 7.0,
            start_angle: 289.983033,
            end_angle: 342.013156,
        },
        {
            center: [51.999669000000004, 157.607224],
            radius: 13.0,
            start_angle: 103.456867,
            end_angle: 179.5911,
        },
        {
            center: [98.00033099999999, 157.607224],
            radius: 13.0,
            start_angle: 0.4089,
            end_angle: 76.543133,
        },
    ],
    lines: [
        {
            x1: 75.0,
            x2: 148.0,
            y1: 0.0,
            y2: 0.0,
        },
        {
            x1: 146.285,
            x2: 130.6822,
            y1: 11.76530000000001,
            y2: 12.879800000000003,
        },
        {
            x1: 150.0,
            x2: 150.0,
            y1: 2.0,
            y2: 7.775500000000008,
        },
        {
            x1: 83.25,
            x2: 83.25,
            y1: 92.25,
            y2: 60.25,
        },
        {
            x1: 111.0,
            x2: 112.0488,
            y1: 157.70000000000002,
            y2: 136.7247,
        },
        {
            x1: 75.0,
            x2: 2.0,
            y1: 0.0,
            y2: 0.0,
        },
        {
            x1: 0.0,
            x2: 0.0,
            y1: 2.0,
            y2: 7.775500000000008,
        },
        {
            x1: 66.75,
            x2: 66.75,
            y1: 92.25,
            y2: 60.25,
        },
        {
            x1: 39.00000000000001,
            x2: 37.95120000000001,
            y1: 157.70000000000002,
            y2: 136.7247,
        },
        {
            x1: 3.7149999999999963,
            x2: 19.3178,
            y1: 11.76530000000001,
            y2: 12.879800000000003,
        },
        {
            x1: 58.50129999999999,
            x2: 30.137700000000002,
            y1: 25.500500000000017,
            y2: 15.18650000000001,
        },
        {
            x1: 91.49869999999999,
            x2: 119.8623,
            y1: 25.500500000000017,
            y2: 15.18650000000001,
        },
        {
            x1: 58.5297,
            x2: 39.9223,
            y1: 126.98910000000001,
            y2: 133.7555,
        },
        {
            x1: 91.51999999999998,
            x2: 110.0777,
            y1: 127.00720000000001,
            y2: 133.7555,
        },
    ],
};

const REPW979A = {
    arcs: [
        {
            center: [133.532254, 52.77818599999999],
            radius: 40.0,
            start_angle: 250.016483,
            end_angle: 265.914169,
        },
        {
            center: [146.0, 7.775498999999996],
            radius: 4.0,
            start_angle: 0.0,
            end_angle: 85.914761,
        },
        {
            center: [148.0, 2.0],
            radius: 2.0,
            start_angle: 270.0,
            end_angle: 360.0,
        },
        {
            center: [203.24999999999997, 60.249999999999986],
            radius: 120.0,
            start_angle: 180.0,
            end_angle: 193.198628,
        },
        {
            center: [203.24999999999997, 92.24999999999999],
            radius: 120.0,
            start_angle: 167.008442,
            end_angle: 180.0,
        },
        {
            center: [120.51839999999999, 111.7717],
            radius: 35.0,
            start_angle: 162.009694,
            end_angle: 167.701453,
        },
        {
            center: [93.88735399999999, 120.41967100000001],
            radius: 7.0,
            start_angle: 109.983069,
            end_angle: 162.009694,
        },
        {
            center: [120.52249999999998, 40.72539999999999],
            radius: 35.0,
            start_angle: 193.002383,
            end_angle: 197.986844,
        },
        {
            center: [93.890931, 32.07903900000001],
            radius: 7.0,
            start_angle: 197.986844,
            end_angle: 250.016967,
        },
        {
            center: [16.467745999999998, 52.77818599999999],
            radius: 40.0,
            start_angle: 274.085831,
            end_angle: 289.983517,
        },
        {
            center: [4.000000000000007, 7.775498999999996],
            radius: 4.0,
            start_angle: 94.085239,
            end_angle: 180.0,
        },
        {
            center: [2.0, 2.0],
            radius: 2.0,
            start_angle: 180.0,
            end_angle: 270.0,
        },
        {
            center: [-53.25, 60.249999999999986],
            radius: 120.0,
            start_angle: 346.801372,
            end_angle: 360.0,
        },
        {
            center: [-53.25, 92.24999999999999],
            radius: 120.0,
            start_angle: 360.0,
            end_angle: 12.991558,
        },
        {
            center: [29.481599999999993, 111.7717],
            radius: 35.0,
            start_angle: 12.298547,
            end_angle: 17.990306,
        },
        {
            center: [56.112646000000005, 120.41967100000001],
            radius: 7.0,
            start_angle: 17.990306,
            end_angle: 70.016931,
        },
        {
            center: [29.4775, 40.72539999999999],
            radius: 35.0,
            start_angle: 342.013156,
            end_angle: 346.997617,
        },
        {
            center: [56.109069, 32.07903900000001],
            radius: 7.0,
            start_angle: 289.983033,
            end_angle: 342.013156,
        },
        {
            center: [46.989979999999996, 157.30053300000003],
            radius: 8.0,
            start_angle: 157.226164,
            end_angle: 177.137761,
        },
        {
            center: [54.3663, 154.203776],
            radius: 16.0,
            start_angle: 103.835206,
            end_angle: 157.226164,
        },
        {
            center: [67.27932899999999, 101.77045],
            radius: 70.0,
            start_angle: 93.4135,
            end_angle: 103.835208,
        },
        {
            center: [74.999777, -28.00001800000001],
            radius: 200.0,
            start_angle: 86.592125,
            end_angle: 93.407769,
        },
        {
            center: [82.721698, 101.770404],
            radius: 70.0,
            start_angle: 76.166122,
            end_angle: 86.594661,
        },
        {
            center: [95.63351, 154.20403],
            radius: 16.0,
            start_angle: 22.771092,
            end_angle: 76.166122,
        },
        {
            center: [103.00997799999999, 157.300433],
            radius: 8.0,
            start_angle: 2.862956,
            end_angle: 22.771092,
        },
        {
            center: [40.9475, 136.57489099999998],
            radius: 3.0,
            start_angle: 177.137614,
            end_angle: 250.016694,
        },
        {
            center: [109.05249799999999, 136.57488999999998],
            radius: 3.0,
            start_angle: 289.983231,
            end_angle: 2.862378,
        },
    ],
    lines: [
        {
            x1: 75.0,
            x2: 148.0,
            y1: 0.0,
            y2: 0.0,
        },
        {
            x1: 146.285,
            x2: 130.6822,
            y1: 11.765299999999996,
            y2: 12.879799999999989,
        },
        {
            x1: 150.0,
            x2: 150.0,
            y1: 2.0,
            y2: 7.775499999999994,
        },
        {
            x1: 83.25,
            x2: 83.25,
            y1: 92.24999999999999,
            y2: 60.249999999999986,
        },
        {
            x1: 75.0,
            x2: 2.0,
            y1: 0.0,
            y2: 0.0,
        },
        {
            x1: 0.0,
            x2: 0.0,
            y1: 2.0,
            y2: 7.775499999999994,
        },
        {
            x1: 66.75,
            x2: 66.75,
            y1: 92.24999999999999,
            y2: 60.249999999999986,
        },
        {
            x1: 3.7149999999999963,
            x2: 19.3178,
            y1: 11.765299999999996,
            y2: 12.879799999999989,
        },
        {
            x1: 58.50129999999999,
            x2: 30.137700000000002,
            y1: 25.500500000000002,
            y2: 15.186499999999995,
        },
        {
            x1: 91.49869999999999,
            x2: 119.8623,
            y1: 25.500500000000002,
            y2: 15.186499999999995,
        },
        {
            x1: 58.5297,
            x2: 39.9223,
            y1: 126.9891,
            y2: 133.75549999999998,
        },
        {
            x1: 91.51999999999998,
            x2: 110.0777,
            y1: 127.0072,
            y2: 133.75549999999998,
        },
        {
            x1: 39.00000000000001,
            x2: 37.95120000000001,
            y1: 157.7,
            y2: 136.72469999999998,
        },
        {
            x1: 111.0,
            x2: 112.0488,
            y1: 157.7,
            y2: 136.72469999999998,
        },
    ],
};

const REPW549B = {
    arcs: [
        {
            center: [1.5897822839627906, 19.51459769150061],
            radius: 1.59,
            start_angle: 110.0000012521413,
            end_angle: 179.0518233978005,
        },
        {
            center: [4.759999999999906, 6.280194634520839],
            radius: 4.759999999999998,
            start_angle: 180.0,
            end_angle: 264.2299547785443,
        },
        {
            center: [19.051443519687183, 95.06611215449632],
            radius: 6.349999999999997,
            start_angle: 1.232883165375256,
            end_angle: 69.99999999999953,
        },
        {
            center: [19.049973491871583, 34.31915901239482],
            radius: 6.350000000000002,
            start_angle: 289.9763409595374,
            end_angle: 0.0,
        },
        {
            center: [34.9250029762423, 304.8000000000001],
            radius: 304.8000000000001,
            start_angle: 264.2299289999998,
            end_angle: 270.000000571529,
        },
        {
            center: [1.5901793531712087, 109.87574654291731],
            radius: 1.59,
            start_angle: 180.0,
            end_angle: 249.9882555392906,
        },
        {
            center: [12.700179353171194, 131.7132870882317],
            radius: 12.7,
            start_angle: 94.36367900000036,
            end_angle: 180.0,
        },
        {
            center: [68.26000000000349, 19.535070652304185],
            radius: 1.59,
            start_angle: 359.9998761822147,
            end_angle: 61.22045035755991,
        },
        {
            center: [50.799449813017986, 34.319957362298425],
            radius: 6.349999999999997,
            start_angle: 180.7358448774277,
            end_angle: 249.9999492811088,
        },
        {
            center: [34.92500601664159, 304.80000000000024],
            radius: 304.8000000000001,
            start_angle: 270.0,
            end_angle: 275.770121121056,
        },
        {
            center: [65.09026916389459, 6.280220924547393],
            radius: 4.759999999999998,
            start_angle: 275.7701070459879,
            end_angle: 359.3906811660957,
        },
        {
            center: [34.92500099426849, -159.53998294151893],
            radius: 304.8000000000001,
            start_angle: 90.0,
            end_angle: 94.36364518124473,
        },
        {
            center: [50.74883768235219, 95.07561015670842],
            radius: 6.349999999999997,
            start_angle: 110.0000000000002,
            end_angle: 172.7237902454118,
        },
        {
            center: [34.92497349187039, -159.53998294151756],
            radius: 304.8000000000001,
            start_angle: 85.63784300000022,
            end_angle: 89.99999483014653,
        },
        {
            center: [57.14999901171291, 131.7132740268866],
            radius: 12.7,
            start_angle: 0.0,
            end_angle: 85.67295896417261,
        },
        {
            center: [68.26019873357589, 109.90030879527822],
            radius: 1.59,
            start_angle: 289.6864364925183,
            end_angle: 359.0918524440323,
        },
    ],
    lines: [
        {
            x1: 21.223271429805294,
            x2: 2.0542280744009815,
            y1: 101.03316029648681,
            y2: 108.01456977762012,
        },
        {
            x1: 2.0542280744009815,
            x2: 1.0460610745172971,
            y1: 108.01456977762012,
            y2: 108.38174677757772,
        },
        {
            x1: 0.0,
            x2: 0.0,
            y1: 6.280194634520839,
            y2: 19.540909088231686,
        },
        {
            x1: 25.399973491871606,
            x2: 25.399973491871606,
            y1: 64.69503008823173,
            y2: 95.2027400882317,
        },
        {
            x1: 21.219337254727094,
            x2: 1.0459702234226995,
            y1: 28.351214570259913,
            y2: 21.00870894666572,
        },
        {
            x1: 25.399973491871606,
            x2: 25.399973491871606,
            y1: 64.69503008823173,
            y2: 34.31915901239482,
        },
        {
            x1: 34.92431399999978,
            x2: 34.9249999999999,
            y1: 33.338144088231715,
            y2: 33.340030088231615,
        },
        {
            x1: 34.923983999999905,
            x2: 34.9250429999999,
            y1: 96.0472670882317,
            y2: 96.04688208823171,
        },
        {
            x1: 34.9250429999999,
            x2: 34.9249999999999,
            y1: 96.04688208823171,
            y2: 96.04686608823172,
        },
        {
            x1: 0.0001793531712053209,
            x2: 0.0001793531712053209,
            y1: 109.87574654291731,
            y2: 131.7132870882317,
        },
        {
            x1: 44.4499734918715,
            x2: 44.4499734918715,
            y1: 64.69503008823173,
            y2: 34.238407088231725,
        },
        {
            x1: 48.62761662080038,
            x2: 69.0254909780881,
            y1: 28.352911142837712,
            y2: 20.928671586026326,
        },
        {
            x1: 69.84999999999991,
            x2: 69.84999999999991,
            y1: 6.229601088235711,
            y2: 19.535067216260487,
        },
        {
            x1: 44.4499734918715,
            x2: 44.4499734918715,
            y1: 64.69503008823173,
            y2: 95.8798550882318,
        },
        {
            x1: 34.925512999999796,
            x2: 34.9249999999999,
            y1: 96.04862008823173,
            y2: 96.05003008823181,
        },
        {
            x1: 48.57700977223419,
            x2: 67.64617016259899,
            y1: 101.04265829869891,
            y2: 107.9847161003976,
        },
        {
            x1: 67.64617016259899,
            x2: 68.79582581247959,
            y1: 107.9847161003976,
            y2: 108.40324378922622,
        },
        {
            x1: 69.8499990117129,
            x2: 69.8499990117129,
            y1: 109.87510808823171,
            y2: 131.7132740268866,
        },
    ],
};

export const IDEAL_PROFILE_RECORD = {
    BR109: REPW002B,
    BR98: REPW008B,
    BS110A: REPW200B,
    BS113A: REPW620F,
    BS95RBH: REPW549B,
    CEN56E1: REPW792,
    CEN60E1: REPW901,
    "60E2": REPW979A,
};

// CAD_RAIL_PROFILES: Dict[RailTypeName, RailTypeData] = {
//     "60E2": {"dxf": "REPW979A.DXF", "bbox": (0, 100, 250, 400)},
//     "CEN60E1": {"dxf": "REPW901.DXF", "bbox": (0, 100, 250, 400)},
//     "CEN56E1": {"dxf": "REPW792.DXF", "bbox": (157400, -107200, 157650, 0)},
//     "BS113A": {"dxf": "REPW620F.DXF", "bbox": (157400, -107200, 157610, 0)},
//     "BS95RBH": {"dxf": "REPW549B.DXF", "bbox": (-100000, -107200, 157610, 1000000)},
//     "BS110A": {"dxf": "REPW200B.DXF", "bbox": (-200, 0, 50, 250)},
//     "BR98": {"dxf": "REPW008B.DXF", "bbox": (-500, 100, -200, 300)},
//     "BR109": {"dxf": "REPW002B.DXF", "bbox": (500, -200, 750, 100)},
// }
